import { FILTER_KIND, type TEntityFilterConfig } from '../types/filter-config';

export const createEntityFilterConfig = <T extends Record<string, unknown>>(
  config: Omit<TEntityFilterConfig<T>, 'kind'>
): TEntityFilterConfig<T> => ({
  kind: FILTER_KIND.entity,
  ...config,
});
